module.exports = __webpack_public_path__ + "img/Ellipse 48.21e76c6e.svg";